import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { formatDate } from '@/shared/lib/format';
import type { Citation, Panel } from '../api/schemas';
import { PanelFrame } from './PanelFrame';

type Props = { panel: Extract<Panel, { kind: 'house_view' }>; citation: Citation | undefined };

/** The Research Monitor house view, as published. */
export function HouseViewPanel({ panel, citation }: Props) {
  return (
    <PanelFrame
      title={`House view: ${panel.subject}`}
      meta={`Research Monitor, ${formatDate(panel.date)}`}
      citation={citation}
    >
      <Stack sx={{ px: 1.75, pb: 1.5, gap: 0.75 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
          {panel.view}
        </Typography>
        {panel.tradingView ? (
          <Typography variant="body2">
            <Typography component="span" variant="body2" sx={{ fontWeight: 600 }}>
              Trading view:{' '}
            </Typography>
            {panel.tradingView}
          </Typography>
        ) : null}
      </Stack>
    </PanelFrame>
  );
}
